module.exports = __webpack_public_path__ + "img/discord.07a23842.svg";